<template>
  <div>
    <span>{{$t('bill.bill_prepaid_amortizing')}}</span> <help-tooltip :text="$t('bill.bill_prepaid_amortizing_tips')" /> :
    <a-switch class="ml-1" :default-checked="defaultChecked" v-model="billShared" @change="change" />
  </div>
</template>

<script>

export default {
  name: 'BillShared',
  props: {
    defaultChecked: {
      type: Boolean,
      default: false,
    },
    billShared: Boolean,
  },
  computed: {
  },
  created () {
  },
  methods: {
    change (e) {
      this.$store.commit('bill/UPDATE_BILL_SHARED', e)
      this.$emit('update:billShared', e)
    },
  },
}
</script>
